import { Stack, Typography } from '@mui/material';

import { FormAwareRadioGroup } from '@/components/form/formAwareInputs/FormAwareRadioGroup';
import { Card } from '@/components/layout/Card/Card';
import { PopperContent } from '@/components/poppers/PopperContent';
import { useFormContext } from '@/components/react-hook-form';
import { EntityLiquidityStatus } from '@/types/schema';

import {
  FullScreenStructuredAssetsModalForm,
  FullScreenStructuredAssetsModalFormPath,
} from './FullScreenStructuredAssetsModal.types';

const LIQUIDITY_OPTIONS = [
  {
    label: 'Asset-level liquidity',
    value: EntityLiquidityStatus.AssetBased,
    contextualHelp: (
      <PopperContent body="When enabled, the liquid assets held inside this entity will be included in the client's overall liquidity calculation." />
    ),
  },
  {
    label: 'Entire entity is liquid',
    value: EntityLiquidityStatus.Liquid,
  },
  {
    label: 'Entire entity is illiquid',
    value: EntityLiquidityStatus.Illiquid,
  },
];

export function LiquidityAssumptionCard() {
  const { control } = useFormContext<FullScreenStructuredAssetsModalForm>();

  return (
    <Card variant="filled">
      <Stack spacing={2} p={2}>
        <Typography variant="title-s" component="span">
          Liquidity assumption
        </Typography>
        <FormAwareRadioGroup<FullScreenStructuredAssetsModalForm>
          fieldName={
            'liquidityStatus' as const satisfies FullScreenStructuredAssetsModalFormPath
          }
          label="Liquidity assumption"
          hideLabel
          control={control}
          options={LIQUIDITY_OPTIONS}
          row={false}
        />
      </Stack>
    </Card>
  );
}
